import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiMenu, FiX, FiLogOut, FiUser, FiGrid } from 'react-icons/fi';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const dashLink = user?.role === 'admin' ? '/admin' : user?.role === 'tutor' ? '/tutor' : '/student';

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 1000,
      background: scrolled ? 'rgba(255,255,255,0.95)' : 'white',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid var(--border)' : '1px solid var(--border)',
      transition: 'all 0.3s',
      boxShadow: scrolled ? 'var(--shadow)' : 'none',
    }}>
      <div className="container-fluid px-4 px-lg-5">
        <div className="d-flex align-items-center justify-content-between" style={{ height: '68px' }}>
          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: '38px', height: '38px', borderRadius: '10px',
              background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '18px', boxShadow: '0 4px 12px rgba(108,99,255,0.3)'
            }}>🎓</div>
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '20px', color: 'var(--dark)' }}>
              Tuition<span style={{ color: 'var(--primary)' }}>Connect</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="d-none d-md-flex align-items-center gap-3">
            {user ? (
              <>
                <Link to={dashLink} style={{ textDecoration: 'none', color: 'var(--gray)', fontSize: '14px', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <FiGrid size={16} /> Dashboard
                </Link>
                <div style={{ width: '1px', height: '20px', background: 'var(--border)' }} />
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                    width: '36px', height: '36px', borderRadius: '50%',
                    background: 'linear-gradient(135deg, var(--primary), var(--secondary))',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: 'white', fontSize: '13px', fontWeight: 700
                  }}>{user.name?.charAt(0).toUpperCase()}</div>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--dark)', lineHeight: 1.2 }}>{user.name}</div>
                    <div style={{ fontSize: '11px', color: 'var(--gray)', textTransform: 'capitalize' }}>{user.role}</div>
                  </div>
                </div>
                <button onClick={handleLogout} style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  padding: '8px 16px', border: '1px solid var(--border)',
                  borderRadius: '10px', background: 'white', color: 'var(--gray)',
                  fontSize: '13px', fontWeight: 500, cursor: 'pointer'
                }}>
                  <FiLogOut size={14} /> Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" style={{ textDecoration: 'none', color: 'var(--gray)', fontSize: '14px', fontWeight: 500 }}>Sign in</Link>
                <Link to="/register">
                  <button className="btn-primary-custom" style={{ padding: '9px 22px', fontSize: '14px' }}>Get Started</button>
                </Link>
              </>
            )}
          </div>

          {/* Mobile menu toggle */}
          <button className="d-md-none" onClick={() => setMenuOpen(!menuOpen)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--dark)', padding: '4px' }}>
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div style={{ borderTop: '1px solid var(--border)', padding: '16px 0', background: 'white' }}>
            {user ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0' }}>
                  <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'linear-gradient(135deg, var(--primary), var(--secondary))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '13px', fontWeight: 700 }}>{user.name?.charAt(0)}</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: 600 }}>{user.name}</div>
                    <div style={{ fontSize: '12px', color: 'var(--gray)', textTransform: 'capitalize' }}>{user.role}</div>
                  </div>
                </div>
                <Link to={dashLink} onClick={() => setMenuOpen(false)} style={{ textDecoration: 'none', color: 'var(--dark)', fontSize: '14px', fontWeight: 500 }}>Dashboard</Link>
                <button onClick={() => { handleLogout(); setMenuOpen(false); }} style={{ textAlign: 'left', background: 'none', border: 'none', color: 'var(--danger)', fontSize: '14px', fontWeight: 500, cursor: 'pointer', padding: 0 }}>Logout</button>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <Link to="/login" onClick={() => setMenuOpen(false)} style={{ textDecoration: 'none', color: 'var(--dark)', fontSize: '14px', fontWeight: 500 }}>Sign in</Link>
                <Link to="/register" onClick={() => setMenuOpen(false)} style={{ textDecoration: 'none' }}>
                  <button className="btn-primary-custom" style={{ width: '100%', padding: '10px' }}>Get Started</button>
                </Link>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
